export default __webpack_public_path__ + "static/media/CheckedBoxIcon.8c9ae53f.svg";